import { configureStore, createSlice } from "@reduxjs/toolkit";

const optionsSlice = createSlice({
    name: "options",
    initialState: {
        headerWidth: 0,
        headerHeight: 0,
        selectLang: false,
    },
    reducers: {
        setHeaderWidth: (state, action) => {
            state.headerWidth = action.payload;
            return state;
        },
        setHeaderHeight: (state, action) => {
            state.headerHeight = action.payload;
            return state;
        },
        openLangSelector: (state, action) => {
            state.selectLang = action.payload;
            return state;
        }
    }
})

export const { setHeaderWidth, setHeaderHeight, openLangSelector } = optionsSlice.actions;

// ------------------------------------------------------------------------------------------------

const worksSlice = createSlice({
    name: "works",
    initialState: [],
    reducers: {
        setWorks: (state, action) => {
            state = action.payload;
            return state;
        }
    }
})

export const { setWorks } = worksSlice.actions;

// ------------------------------------------------------------------------------------------------

const articlesSlice = createSlice({
    name: "articles",
    initialState: [],
    reducers: {
        setArticles: (state, action) => {
            state = action.payload;
            return state;
        }
    }
})

export const { setArticles } = articlesSlice.actions;

// ------------------------------------------------------------------------------------------------
// ------------------------------------------------------------------------------------------------

export const store = configureStore({
    reducer: {
        options: optionsSlice.reducer,
        works: worksSlice.reducer,
        articles: articlesSlice.reducer,
    }
});